import React, { useMemo, Suspense } from 'react';
import { Text, View, ActivityIndicator } from 'react-native';
import { fetchComponent } from '../utils';
import styled from 'styled-components/native';


const DynamicComponent = ({ __id, children, ...props }) => {
  const Component = useMemo(() => {
    return React.lazy(async () => fetchComponent(__id));
  }, [__id]);

  return (
    <Suspense
      fallback={
        <SpinnerContainer>
            <ActivityIndicator size="large"/>
        </SpinnerContainer>
      }
    >
      <Component {...props}>{children}</Component>
    </Suspense>
  );
};

export const SpinnerContainer = styled.View`
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
`

export default React.memo(DynamicComponent);
